module.exports = __webpack_public_path__ + "static/media/vertical-branco.2e6be664.svg";